import type { RouteLocationNormalized } from 'vue-router';
import { SUPPORTED_LOCALES } from '~/utils/locales';

// Matches a bare locale root: '/de' and '/de/' match, '/dex' and '/de/courses' do not
const LOCALE_ROOT_PATTERN = new RegExp(`^/(${SUPPORTED_LOCALES.join('|')})/?$`);

export function isLocaleRootPath (path: string): boolean {
  return LOCALE_ROOT_PATTERN.test(path);
}

export function buildLoginUrl (to: RouteLocationNormalized, loginPath: string): string {
  const qs = new URLSearchParams();

  const isRootPath = to.path === '/' || isLocaleRootPath(to.path);
  if (!isRootPath) {
    qs.set('next', to.fullPath);
  }

  // google cross domain tracking parameter
  const crossDomainTracking = Array.isArray(to.query._gl) ? to.query._gl[0] : to.query._gl;
  if (crossDomainTracking) {
    qs.set('_gl', crossDomainTracking);
  }

  return qs.size ? `${loginPath}?${qs}` : loginPath;
}
